import React, { useState } from 'react';
import {
  IconButton, Popover, Box, Typography, Switch, Divider,
} from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';

/**
 * An icon button that opens a popover listing all columns with visibility toggles.
 * Props:
 *   columns       — ColumnDef[]
 *   onToggle      — (columnId: string) => void
 */
export default function ColumnVisibilityMenu({ columns, onToggle }) {
  const [anchor, setAnchor] = useState(null);

  return (
    <>
      <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)} title="Show/hide columns">
        <ViewColumnIcon />
      </IconButton>

      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box sx={{ p: 2, minWidth: 200 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Columns</Typography>
          <Divider sx={{ mb: 1 }} />
          {columns.filter(c => c.type !== 'image').map((col) => (
            <Box key={col.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="body2">{col.label}</Typography>
              <Switch
                size="small"
                checked={col.visible !== false}
                onChange={() => onToggle(col.id)}
              />
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
}
